import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "sonner"
import ErrorBoundary from "@/components/ErrorBoundary"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Pages />
        <Toaster />
      </ErrorBoundary>
    </QueryClientProvider>
  )
}

export default App